import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list", "item", "handle", "empty"]
  static values = {
    reorderUrl: String,
    navigationId: Number
  }

  connect() {
    if (!this.hasListTarget) return

    this.sortable = Sortable.create(this.listTarget, {
      handle: "[data-navbar-builder-target='handle']",
      animation: 150,
      ghostClass: "opacity-30",
      onEnd: () => this.handleDragEnd()
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  handleDragEnd() {
    const items = this.serializeTree()
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ items })
    })
      .then(response => {
        if (!response.ok) {
          console.error("Reorder failed:", response.statusText)
        }
      })
      .catch(error => console.error("Reorder error:", error))
  }

  serializeTree() {
    const rows = this.listTarget.querySelectorAll("[data-item-id]")
    const items = []

    rows.forEach((row, index) => {
      items.push({
        id: parseInt(row.dataset.itemId),
        parent_id: row.dataset.parentId || null,
        position: index
      })
    })

    return items
  }
}
